import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';
import { CommonModule } from '@angular/common';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { OrderRoutingModule } from 'app/modules/order/order-routing.module';
import { OrderEditDeliveryComponent } from '../order/order-edit-delivery/order-edit-delivery.component';
import { OrderEditDetailComponent } from '../order/order-edit-detail/order-edit-detail.component';
import { OrderEditPlanningComponent } from '../order/order-edit-planning/order-edit-planning.component';
import { OrderEditContainer } from '../order/order-edit-container/order-edit.container';
import { OrderEditMaterialComponent } from '../order/order-edit-material/order-edit-material.component';
import { OrderMaterialLinesComponent } from '../order/order-material-lines/order-material-lines.component';
import { PoNumberAsyncValidator } from '../florder/florder-edit-delivery/po-number-async-validator';
import { OrderDocumentsComponent } from '../order/order-documents/order-documents.component';
import { OrdersRecurrenceModalComponent } from '../order/orders-recurrence-modal/orders-recurrence-modal.component';

@NgModule({
  imports: [CommonModule, FlorderModule, OrderRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [OrderEditDeliveryComponent, OrderEditDetailComponent, OrderEditPlanningComponent, OrderDocumentsComponent],
  declarations: [
    OrderEditDeliveryComponent,
    OrderEditDetailComponent,
    OrderEditPlanningComponent,
    OrderEditMaterialComponent,
    OrderMaterialLinesComponent,
    OrderEditContainer,
    OrderDocumentsComponent,
    OrdersRecurrenceModalComponent,
  ],
  providers: [PoNumberAsyncValidator],
})
export class OrderModule {}
